module.exports = "/images/cooper-10.jpg";